export const runningString = [
	{
		id: 1,
		title: 'инновации'
	},
	{
		id: 2,
		title: 'спасение жизней'
	},
	{
		id: 3,
		title: 'биотехнологии'
	},
	{
		id: 4,
		title: 'здоровье'
	},
	{
		id: 5,
		title: 'исследования'
	},
	{
		id: 6,
		title: 'клинические испытания'
	},
	{
		id: 7,
		title: 'команда профессионалов'
	},
	{
		id: 8,
		title: 'развитие'
	},
	{
		id: 9,
		title: 'забота'
	},
	{
		id: 10,
		title: 'нестандартные задачи'
	}
]
